module.exports = __webpack_public_path__ + "img/content4.000f0e63.png";